// NPM Imports
import React, { Component } from "react";
import Tooltip from "rc-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Internal Imports
import { DRAFT } from "../../constants";
import { checkBlockTypeBtnStatus } from "../../utils/draftUtils";

// Destructuring
const { TOOLBAR_HEADER_BUTTONS } = DRAFT;

class HeaderButtons extends Component {
  state = {
    activeStatus: "Normal Text",
  };

  componentWillMount = () => {
    document.addEventListener("mousedown", this._handleClick, false);
  };

  componentDidMount = () => {
    TOOLBAR_HEADER_BUTTONS.forEach(btn => {
      const { editorState } = this.props;
      if (checkBlockTypeBtnStatus(editorState, btn.type)) {
        this.setState({
          activeStatus: btn.value,
        });
      }
    });
    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }
  };

  componentDidUpdate = prevProps => {
    if (
      prevProps.editorState.getSelection().getAnchorOffset() !==
      this.props.editorState.getSelection().getAnchorOffset()
    ) {
      TOOLBAR_HEADER_BUTTONS.forEach(btn => {
        const { editorState } = this.props;
        if (checkBlockTypeBtnStatus(editorState, btn.type)) {
          this.setState({
            activeStatus: btn.value,
          });
        }
      });
    } else {
      const oldBlockType = this._getBlockType(prevProps.editorState);
      const newBlockType = this._getBlockType(this.props.editorState);
      if (oldBlockType !== newBlockType) {
        let HeaderStyle = "Normal Text";
        if (newBlockType === "header-one") {
          HeaderStyle = "Header 1";
        } else if (newBlockType === "header-two") {
          HeaderStyle = "Header 2";
        } else if (newBlockType === "header-three") {
          HeaderStyle = "Header 3";
        } else if (newBlockType === "header-four") {
          HeaderStyle = "Header 4";
        } else if (
          newBlockType === "unordered-list-1" ||
          newBlockType === "ordered-list-1"
        ) {
          TOOLBAR_HEADER_BUTTONS.forEach(btn => {
            const { editorState } = this.props;
            if (checkBlockTypeBtnStatus(editorState, btn.type)) {
              HeaderStyle = btn.value;
            }
          });
        }
        this.setState({
          activeStatus: HeaderStyle,
        });
      }
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this._handleClick, false);
  };

  _getBlockType = editorState => {
    if (editorState) {
      const contentState = editorState.getCurrentContent();
      const selectionState = editorState.getSelection();
      const blockKey = selectionState.getAnchorKey();
      const blockType = contentState.getBlockForKey(blockKey).getType();
      return blockType;
    }
    return "";
  };

  _handleClick = e => {
    if (
      !this.node.contains(e.target) &&
      this.props.activeToolbarDropDown === "HEADER_BUTTONS"
    ) {
      this.props.toogleToolbarDropDown(null);
    }
  };

  _onChange = (event, headerType) => {
    event.preventDefault();
    if (headerType === "unstyled") {
      this.props.handleNormalText();
    } else {
      this.props.handleHeaderButton(headerType);
    }
    TOOLBAR_HEADER_BUTTONS.forEach(btn => {
      if (btn.type === headerType) {
        this.setState({
          activeStatus: btn.value,
        });
      }
    });
    this.props.toogleToolbarDropDown(null);
  };

  _toggleDropdown = event => {
    event.preventDefault();
    this.props.toogleToolbarDropDown(
      this.props.activeToolbarDropDown === "HEADER_BUTTONS"
        ? null
        : "HEADER_BUTTONS",
    );
  };

  // This method is being used here to handle the only eslint issue
  _getFontSize = fontSize => ({ fontSize });

  render() {
    return (
      <div
        className="draft-edit-items"
        ref={ele => {
          this.node = ele;
        }}>
        {/* ------- Header dropdown button section ------ */}
        <Tooltip
          placement="top"
          overlay="Styles"
          align={{
            offset: [3, 0],
          }}>
          <button
            data-test="toolbar-header-dropdown-button"
            type="button"
            className={`toolbar-custom-inline-button toolbar-btn option-font-type ${
              this.props.activeToolbarDropDown === "HEADER_BUTTONS"
                ? "active"
                : ""
            }`}
            onMouseDown={this._toggleDropdown}>
            <span className="font-title">{this.state.activeStatus}</span>
            <i className="ic-dropdown">
              <FontAwesomeIcon
                icon={["far", "angle-down"]}
                className="breadcrumb-bredcrumb-icon"
              />
            </i>
          </button>
        </Tooltip>
        {/* ------- Header dropdown list section ------ */}
        {this.props.activeToolbarDropDown === "HEADER_BUTTONS" && (
          <div className="headerbuttons-style-wrapper">
            <ul className="headerbuttons-style-options">
              {TOOLBAR_HEADER_BUTTONS.map(btn => (
                <li
                  key={btn.type}
                  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                  role="button"
                  tabIndex={0}
                  onMouseDown={event => this._onChange(event, btn.type)}
                  style={this._getFontSize(btn.fontSize)}>
                  <div
                    className={`headerbuttons-style-option ${
                      this.state.activeStatus === btn.value ? "active" : ""
                    }`}>
                    {btn.value}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

export default HeaderButtons;



// WEBPACK FOOTER //
// ./src/components/RevvToolBar/HeaderButtons.js